













import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import Layout from './Layout.vue';
import Post from './Post.vue';
@Component({
  components: {
    Layout,
    Post,
  },
})
export default class PostDetails extends Vue {
  async mounted() {
    vxm.forum.fetchReportReasons();
    vxm.forum.fetchPostDetails(this.$route.params.postId);
    vxm.forum.fetchCategories();
  }
  get postDetails() {
    return vxm.forum.PostList[0];
  }
}
